import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import { useChangePasswordMutation } from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

export function useChangePassword() {
  const toastStore = useToastStore()
  const webviewStore = useWebviewStore()
  const router = useRouter()

  const currentPassword = ref('')
  const newPassword = ref('')
  const confirmPassword = ref('')
  const currentPasswordError = ref('')
  const confirmPasswordError = ref('')

  const { mutate: changePassword, loading } = useChangePasswordMutation()

  const canSave = computed(
    () =>
      !!currentPassword.value.trim() &&
      !!newPassword.value.trim() &&
      !!confirmPassword.value.trim()
  )

  watch(currentPassword, () => {
    currentPasswordError.value = ''
  })

  watch([newPassword, confirmPassword], () => {
    confirmPasswordError.value = ''
  })

  const save = async () => {
    if (!canSave.value) return false

    if (newPassword.value !== confirmPassword.value) {
      confirmPasswordError.value = 'Passwords do not match.'
      return false
    }

    try {
      await changePassword({
        oldPassword: currentPassword.value,
        newPassword: newPassword.value,
      })

      toastStore.showToast({
        type: ToastType.Success,
        content: 'Password changed successfully',
      })

      return true
    } catch (error) {
      if (error instanceof Error && error.message.includes('incorrect')) {
        currentPasswordError.value = 'Password is incorrect.'
      }
      return false
    }
  }

  const forgotPassword = async () => {
    if (webviewStore.isActive) {
      webviewStore.postMessage({ type: NativeActionsEnum.OpenForgotPassword })
    } else {
      await router.push('/forgot-password')
    }
  }

  return {
    currentPassword,
    newPassword,
    confirmPassword,
    currentPasswordError,
    confirmPasswordError,
    loading,
    canSave,
    save,
    forgotPassword,
  }
}
